import { render, staticRenderFns } from "./LogoOnlyHeader.vue?vue&type=template&id=cfba82a6&"
import script from "./LogoOnlyHeader.vue?vue&type=script&lang=ts&"
export * from "./LogoOnlyHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports